var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnrolled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3327 20.0003L19.3327 14.0003L11.3327 8.00033V20.0003ZM13.9993 0.666992C6.63268 0.666992 0.666016 6.63366 0.666016 14.0003C0.666016 21.367 6.63268 27.3337 13.9993 27.3337C21.366 27.3337 27.3327 21.367 27.3327 14.0003C27.3327 6.63366 21.366 0.666992 13.9993 0.666992ZM13.9993 24.667C8.11935 24.667 3.33268 19.8803 3.33268 14.0003C3.33268 8.12033 8.11935 3.33366 13.9993 3.33366C19.8793 3.33366 24.666 8.12033 24.666 14.0003C24.666 19.8803 19.8793 24.667 13.9993 24.667Z",
    fill: "#9D4300"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnrolled);
export default __webpack_public_path__ + "static/media/enrolled.21d6d06e5936c8460a66708dc4df774b.svg";
export { ForwardRef as ReactComponent };